import React from "react";

function Section2Banner() {
  return (
    <div className="section2Banner">
      <p className="section2Banner-header1">
        Privacy - like eating and breathing - is one of life's basic
        requirements.
      </p>
      <p className="section2Banner-header2">
        Security used to be an inconvenience sometimes, but now it's a necessity
        all the time.
      </p>
    </div>
  );
}

export default Section2Banner;
